import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import PLAN_URL from "../utils/PLAN_URL";

export const useInformationDataPlan = (group_code, project_code) => {
  const [loading, setLoading] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [infoData, setInfoData] = useState({});
  const user = useSelector((state) => state.auth.user);
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        // 29 자리에 user.username
        let initialData = {};
        const res = await axios.get(
          PLAN_URL +
            `/api/item/getAllItems?group_code=${group_code}&project_code=${project_code}`
        );
        // const machineList = await axios.get(
        //   API_URL + "/getInsightwinMachineList"
        // );
        // const processList = await axios.get(
        //   API_URL + "/getInsightwinProcessList"
        // );
        // const orderList = await axios.get(API_URL + "/api/orders/getAllOrder");
        // const lotList = await axios.get(API_URL + "/getInsightwinLotList");
        // const nextGanttId = await axios.get(API_URL + "/getNextGanttId");
        // const nextTaskId = await axios.get(API_URL + "/getNextTaskId");
        // const res = await axios.get(`${API_URL}/getItemList?username=user29`);
        // const machineList = await axios.get(
        //   `${API_URL}/getMachineList?username=user29`
        // );
        // const processList = await axios.get(
        //   `${API_URL}/getProcessList?username=user29`
        // );
        // const orderList = await axios.get(
        //   `${API_URL}/getOrderList?username=user29`
        // );
        initialData.item = res.data;
        // initialData.machine = machineList.data[0];
        // initialData.process = processList.data[0];
        // initialData.order = orderList.data[0];
        // initialData.lot = lotList.data[0];
        // initialData.nextGanttId = nextGanttId.data.next_gantt_id;
        // initialData.nextTaskId = nextTaskId.data.next_task_id;
        setInfoData(initialData);
        setLoading(false);
        initialData = null;
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    }
    fetchData();
  }, []);
  useEffect(() => {
    async function fetchDataAgain() {
      try {
        if (updateStatus) {
          setLoading(true);
          // 29 자리에 user.username
          let initialData = {};
          const res = await axios.get(PLAN_URL + "/getInsightwinItemList");
          // const machineList = await axios.get(
          //   API_URL + "/getInsightwinMachineList"
          // );
          // const processList = await axios.get(
          //   API_URL + "/getInsightwinProcessList"
          // );
          // const orderList = await axios.get(
          //   API_URL + "/api/orders/getAllOrder"
          // );
          // const lotList = await axios.get(API_URL + "/getInsightwinLotList");
          // const res = await axios.get(`${API_URL}/getItemList?username=user29`);
          // const machineList = await axios.get(
          //   `${API_URL}/getMachineList?username=user29`
          // );
          // const processList = await axios.get(
          //   `${API_URL}/getProcessList?username=user29`
          // );
          // const orderList = await axios.get(
          //   `${API_URL}/getOrderList?username=user29`
          // );
          initialData.item = res.data;
          // initialData.machine = machineList.data[0];
          // initialData.process = processList.data[0];
          // initialData.order = orderList.data[0];
          // initialData.lot = lotList.data[0];
          setInfoData(initialData);
          setLoading(false);
          initialData = null;
          setUpdateStatus(false);
        }
      } catch (e) {
        console.log(e);
        setLoading(false);
        setUpdateStatus(false);
      }
    }
    fetchDataAgain();
  }, [updateStatus]);
  return {
    loading,
    setUpdateStatus,
    infoData,
    setInfoData,
  };
};

export default useInformationDataPlan;
